<div class="sticky mt-4 mt-lg-0 mwx-650">
          <div class="glow"></div>
          <!-- <img class="logo img-fluid mwx-34" src="/assets/images/png/token-icon.png" alt="SeerDex Logo"
            loading="lazy" />
          <span class="tag"><span class="dot"></span> BONUS STAGE NOW LIVE</span> -->
          <div class="d-md-flex align-items-start justify-content-between">
            <div>
              <h3 [innerHTML]="'race_to.title' | translate"></h3>
              <div class="my-2" style="color:var(--mute);font-size:18px">{{"race_to.subtitle" | translate}}</div>
              <p class="sub-text">{{"race_to.desc" | translate}}</p>
                <a class="readmore mb-3 mb-md-0" href="https://seerdex.gitbook.io/seerdex-whitepaper" target="_blank"
            rel="noopener noreferrer">
            <strong>{{ "race_to.read_more"  | translate }}</strong>
          </a>
            </div>
            <ul class="chk my-0" id="chkList">
              <li><svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="#C3F500" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                </svg><span>{{"race_to.race_to_1" | translate}}</span><span class="done text-primary">{{"race_to.live" | translate}}</span></li>
              <li><svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="#C3F500" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                </svg><span>{{"race_to.race_to_2" | translate}}</span><span class="done text-primary">{{"race_to.live" | translate}}</span></li>
              <li><svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="#C3F500" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                </svg><span>{{"race_to.race_to_3" | translate}}</span><span class="done">{{"race_to.open" | translate}}</span></li>
              <li><svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="#C3F500" stroke-width="3" stroke-linecap="round"
                    stroke-linejoin="round"></path>
                </svg><span>{{"race_to.race_to_4" | translate}}</span><span class="done">{{"race_to.started" | translate}}</span></li>
            </ul>
          </div>



        </div>